import React, { useState } from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
const ExpandIcon = ({ isActive }) => (React.createElement(CaretRightOutlined, { style: { fontSize: 16, color: "#265AB1" }, rotate: isActive ? 90 : 0 }));
const ExpandableContactEmailsList = ({ emails }) => {
    // Collapse takes array of active keys, but just using one panel here like a boolean
    const [isExpanded, setIsExpanded] = useState([]);
    const handleChange = (keys) => {
        setIsExpanded(Array.isArray(keys) ? keys : [keys]);
    };
    return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
        React.createElement("span", null, `${emails.length} email${emails.length > 1 ? "s" : ""} set`),
        React.createElement(Collapse, { ghost: true, expandIcon: ExpandIcon, activeKey: isExpanded, onChange: handleChange },
            React.createElement(Collapse.Panel, { header: React.createElement("span", { style: { color: "#265AB1", fontSize: 14, display: "flex", alignItems: "center", height: "22px" } }, isExpanded.length > 0 ? "Hide Emails" : "Show Emails"), style: { background: "white" }, key: "true" },
                React.createElement("ul", { style: {
                        listStyleType: "disc",
                        maxHeight: 300,
                        overflow: "auto",
                    } }, emails.map(email => (React.createElement("li", { key: email }, email))))))));
};
export default ExpandableContactEmailsList;
